// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__gJ6mR","image":"App_image__AcPVM"};